import { render, staticRenderFns } from "./SvgLuckOfferType.vue?vue&type=template&id=da6565e6&scoped=true"
import script from "./SvgLuckOfferType.vue?vue&type=script&lang=js"
export * from "./SvgLuckOfferType.vue?vue&type=script&lang=js"
import style0 from "./SvgLuckOfferType.vue?vue&type=style&index=0&id=da6565e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da6565e6",
  null
  
)

export default component.exports